export class AlternativePriceModel{
    constructor(public IsEnabled: boolean,
                public CalculationRule: string = null,
                public IsCalculationRuleValid: boolean = false) {
    }
}